import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/Button';

const convertSpecialChar = (src) => {
  if (!src) {
    return '';
  }
  src.toString().replace(/"/g, '\'');
  return src;
};

const convertToCSV = (args) => {
  const data = args.data || null;
  if (data == null || !data.length) {
    return null;
  }

  const columnWrapper = args.columnWrapper || '"';
  const columnDelimiter = args.columnDelimiter || ',';
  const lineDelimiter = args.lineDelimiter || '\n';

  const keys = Object.keys(data[0]);

  let result = '';

  data.forEach((item) => {
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += columnWrapper + convertSpecialChar(item[key]) + columnWrapper;
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
};

export const downloadCSV = (csvData, csvFileName) => {
  const csv = convertToCSV({
    data: csvData,
  });
  if (csv == null) return;

  const blob = new Blob([csv], { type: 'text/csv' });
  const csvUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('href', csvUrl);
  link.setAttribute('download', csvFileName);
  link.click();
};

export const CSVExport = (props) => {
  const { title, className, onClick, isLoading, isDisabled } = props;
  return (
    <Button
      className={className}
      isLoading={isLoading}
      disabled={isDisabled}
      onClick={onClick}
    >
      {title}
    </Button>
  );
};

CSVExport.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
};

CSVExport.defaultProps = {
  className: '',
  title: 'CSV Export',
  isLoading: false,
  isDisabled: false,
  onClick: () => {},
};

export default CSVExport;



// WEBPACK FOOTER //
// ./src/components/CSVExport/index.js